import { Button, Col, Form, Modal, Row, Statistic, Typography } from "antd";
import DynamicForm from "../controls/DynamicForm";
import { useEffect } from "react";
import dayjs from "dayjs";
import { Notification } from "../repository/data.default";

export interface NotificationViewProps {
  readonly notification?: Notification;
  readonly open?: boolean;
  readonly onCancel?: () => void;
  /** Drill into this notification's per-recipient receipts (Sent / Delivered / Read). */
  readonly onViewReceipts?: (notification: Notification) => void;
}

function NotificationView(props: NotificationViewProps) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.open && props.notification) {
      form.setFieldsValue(props.notification);
    }
  }, [props.open, props.notification]);

  function onCancel(): void {
    props.onCancel?.();
  }

  const n = props.notification;

  return (
    <Modal
      open={props.open}
      centered
      title={"Notification"}
      maskClosable={false}
      onCancel={onCancel}
      footer={[
        <Button key="close" onClick={onCancel}>
          Close
        </Button>,
        <Button
          key="receipts"
          type="primary"
          disabled={!n}
          onClick={() => n && props.onViewReceipts?.(n)}
        >
          View receipts
        </Button>,
      ]}
    >
      <Col className="flex max-h-[512px] w-[720px] flex-col overflow-hidden overflow-y-auto">
        {/* Delivery proof roll-up across this notification's recipients. */}
        <Row className="mb-2 flex flex-row flex-wrap gap-6 pl-1">
          <Statistic title="Recipients" value={n?.recipientsCount ?? 0} />
          <Statistic title="Sent" value={n?.sentCount ?? 0} />
          <Statistic title="Delivered" value={n?.deliveredCount ?? 0} />
          <Statistic title="Read" value={n?.readCount ?? 0} />
        </Row>
        <Typography.Text type="secondary" className="mb-3 pl-1 text-xs">
          Sent → Delivered (device received) → Read (user opened).
        </Typography.Text>
        <DynamicForm
          form={form}
          preview
          schema={{
            groups: [
              {
                controls: [
                  { type: "labelbox", name: "title", label: "Title" },
                  { type: "labelbox", name: "message", label: "Message" },
                  { type: "labelbox", name: "type", label: "Type" },
                  {
                    type: "labelbox",
                    name: "scheduledAt",
                    label: "Scheduled At",
                    format: (value) =>
                      value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "",
                  },
                  { type: "labelbox", name: "isSent", label: "Is Sent" },
                  {
                    type: "labelbox",
                    name: "sentByUserName",
                    label: "Sent By User",
                  },
                  {
                    type: "labelbox",
                    name: "sentAt",
                    label: "Sent At",
                    format: (value) =>
                      value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "",
                  },
                  {
                    type: "labelbox",
                    name: "createdOn",
                    label: "Created On",
                    format: (value) =>
                      value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "",
                  },
                ],
              },
            ],
          }}
        />
      </Col>
    </Modal>
  );
}

export default NotificationView;
